<template>
  <div v-for="(item, index) in pages" :key="item.id">
    <div v-if="item.is_group">
      <Disclosure v-slot="{ open }" :default-open="calcGroupOpen(item)">
        <DisclosureButton
          class="relative flex items-center !w-full gap-2 px-2 py-5 text-sm text-white rounded-md cursor-pointer"
          @click="() => handleOpenGroup(item, !open)">
          <div class="border border-white rounded-md">
            <ChevronDown :class="{ '-rotate-90': !open }" class="w-5 h-5 text-white transition-all duration-500 ease-in-out" />
          </div>
          {{ item.name }}
        </DisclosureButton>
        <transition name="fade">
          <DisclosurePanel class="text-gray-500">
            <div
              :style="{ height: `${65 * item.pages.length}px` }"
              class="bg-white h-0 transition-all duration-500 ease-in-out delay-500 w-[1px] -mt-5 absolute left-[18px] z-40" />

            <li
              v-for="page in item.pages"
              :key="page.id"
              class="group/tab w-[98%] py-[2px] relative text-center justify-center text-white"
              @mouseleave="page_hovered = null"
              @mouseenter="page_hovered = useSlugForStaticPages && page.is_static ? page.slug : page.id"
              @click="
                () => {
                  if (customPageClickFunction) customPageClickFunction(useSlugForStaticPages && page.is_static ? page.slug : page.id)
                  else $router.push(useSlugForStaticPages && page.is_static ? page.slug : page.id)
                }
              ">
              <div
                v-if="
                  current_page === (useSlugForStaticPages && page.is_static ? page.slug : page.id) ||
                    page_hovered == (useSlugForStaticPages && page.is_static ? page.slug : page.id)
                "
                :style="{ backgroundColor: getTwBgColor(useSlugForStaticPages && page.is_static ? page.slug : page.id) }"
                class="w-[98%] ml-0 h-12 absolute mt-1 rounded-r-lg z-0" />
              <div :class="['cursor-pointer flex w-full items-center pl-5 px-3 py-5 text-sm rounded-md relative z-10']">
                <span class="bg-white -ml-[7px] w-3 h-3 rounded-full mr-2" />
                {{ page.name }}
                <span v-if="page.is_shared" class="ml-1 has-tooltip">
                  <div class="flex-wrap p-2 mt-5 text-white bg-gray-700 rounded -ml-28 tooltip whitespace-nowrap">
                    {{ $t("Shared with") }} {{ getSharedWithText(page.shared_with) }}
                  </div>

                  <Share2 :color="getIconColor(useSlugForStaticPages && page.is_static ? page.slug : page.id)" />
                </span>
                <span v-if="!page.is_static && page.page !== 'dashboard'"
                      class="ml-1"><LayoutTemplate class="w-4 h-4" :color="getIconColor(useSlugForStaticPages && page.is_static ? page.slug : page.id)" />
                </span>
              </div>
              <BlueArcVector
                v-if="
                  current_page === (useSlugForStaticPages && page.is_static ? page.slug : page.id) ||
                    page_hovered == (useSlugForStaticPages && page.is_static ? page.slug : page.id)
                "
                :color="getBgColor(useSlugForStaticPages && page.is_static ? page.slug : page.id)"
                class="absolute -left-[1px] -top-1" />
              <BlueArcVector2
                v-if="
                  current_page === (useSlugForStaticPages && page.is_static ? page.slug : page.id) ||
                    page_hovered == (useSlugForStaticPages && page.is_static ? page.slug : page.id)
                "
                :color="getBgColor(useSlugForStaticPages && page.is_static ? page.slug : page.id)"
                class="absolute -left-[1px] -bottom-0" />
            </li>
          </DisclosurePanel>
        </transition>
      </Disclosure>
    </div>

    <li
      v-else
      class="group/tab w-[98%] py-[2px] relative text-center justify-center text-white truncate max-w-[98%]"
      @mouseleave="page_hovered = null"
      @mouseenter="page_hovered = useSlugForStaticPages && item.is_static ? item.slug : item.id"
      @click="
        () => {
          if (customPageClickFunction) customPageClickFunction(useSlugForStaticPages && item.is_static ? item.slug : item.id)
          else $router.push(useSlugForStaticPages && item.is_static ? item.slug : item.id)
        }
      ">
      <div
        v-if="
          current_page === (useSlugForStaticPages && item.is_static ? item.slug : item.id) ||
            page_hovered == (useSlugForStaticPages && item.is_static ? item.slug : item.id)
        "
        :style="{ backgroundColor: getTwBgColor(useSlugForStaticPages && item.is_static ? item.slug : item.id) }"
        class="w-[98%] ml-0 h-12 absolute mt-1 rounded-r-lg z-0" />
      <div :class="['cursor-pointer flex w-full items-center pl-5 px-3 py-5 text-sm rounded-md relative z-10']">
        {{ item.name }}
        <span v-if="!item.is_static && item.page !== 'dashboard'"
              class="ml-1"><LayoutTemplate class="w-4 h-4" :color="getIconColor(useSlugForStaticPages && item.is_static ? item.slug : item.id)" />
        </span>
      </div>
      <BlueArcVector
        v-if="
          current_page === (useSlugForStaticPages && item.is_static ? item.slug : item.id) ||
            page_hovered == (useSlugForStaticPages && item.is_static ? item.slug : item.id)
        "
        :color="getBgColor(useSlugForStaticPages && item.is_static ? item.slug : item.id)"
        class="absolute -left-[1px] -top-[3.5px]" />
      <BlueArcVector2
        v-if="
          current_page === (useSlugForStaticPages && item.is_static ? item.slug : item.id) ||
            page_hovered == (useSlugForStaticPages && item.is_static ? item.slug : item.id)
        "
        :color="getBgColor(useSlugForStaticPages && item.is_static ? item.slug : item.id)"
        class="absolute -left-[1px] bottom-0" />
    </li>
    <li
      v-if="$route.name == 'Forecasting' && pages.length == index + 1"
      :class="[getTextColor(useSlugForStaticPages && item.is_static ? item.slug : item.id)]"
      class="group/tab w-[98%] py-[2px] relative text-center justify-center"
      @mouseleave="page_hovered = null"
      @mouseenter="page_hovered = useSlugForStaticPages && item.is_static ? item.slug : item.id"
      @click="$emitter.emit(ALL_EMITTERS.SETUP_FORECASTING_MODAL)">
      <div
        v-if="
          current_page === (useSlugForStaticPages && item.is_static ? item.slug : item.id) ||
            page_hovered == (useSlugForStaticPages && item.is_static ? item.slug : item.id)
        "
        :class="[getTwBgColor(useSlugForStaticPages && item.is_static ? item.slug : item.id)]"
        class="w-[98%] ml-0 h-12 absolute mt-1 rounded-r-full z-0" />
      <div :class="['cursor-pointer flex w-full items-center pl-5 px-3 py-5 text-sm rounded-md relative z-10']">
        {{ $t("Set up forecasting") }} <Plus class="text-white w-5 h-5 ml-2" aria-hidden="true" />
      </div>
    </li>
  </div>

  <div v-if="sharedPages.length > 0">
    <Disclosure v-slot="{ open }" :default-open="calcSharedGroupOpen()">
      <DisclosureButton
        class="relative flex items-center !w-full gap-2 px-2 py-5 text-sm text-white rounded-md cursor-pointer"
        @click="() => handleOpenShared(!open)">
        <div class="border border-white rounded-md">
          <ChevronDown :class="{ '-rotate-90': !open }" class="w-5 h-5 text-white transition-all duration-500 ease-in-out" />
        </div>
        {{ $t("Shared Layouts") }}
      </DisclosureButton>
      <transition name="fade">
        <DisclosurePanel class="text-gray-500">
          <div
            :style="{ height: `${65 * sharedPages.length}px` }"
            class="bg-white h-0 transition-all duration-500 ease-in-out delay-500 w-[1px] -mt-5 absolute left-[18px] z-40" />
          <li
            v-for="page in sharedPages"
            :key="page"
            class="group/tab w-[98%] py-[2px] relative text-center justify-center text-white"
            @mouseleave="page_hovered = null"
            @mouseenter="page_hovered = useSlugForStaticPages && page.is_static ? page.slug : page.id"
            @click="$router.push(`/dashboard/${useSlugForStaticPages && page.is_static ? page.slug : page.id}`)">
            <div
              v-if="
                current_page === (useSlugForStaticPages && page.is_static ? page.slug : page.id) ||
                  page_hovered == (useSlugForStaticPages && page.is_static ? page.slug : page.id)
              "
              :style="{ backgroundColor: getTwBgColor(useSlugForStaticPages && page.is_static ? page.slug : page.id) }"
              class="w-[98%] ml-0 h-12 absolute mt-1 rounded-r-lg z-0" />
            <div :class="['cursor-pointer flex w-full items-center pl-5 px-3 py-5 text-sm rounded-md relative z-10']">
              <span class="bg-white -ml-[7px] w-3 h-3 rounded-full mr-2" />
              {{ page.name }}
              <span v-if="page.is_shared"
                    class="ml-2 has-tooltip"><Share2 :color="getIconColor(useSlugForStaticPages && page.is_static ? page.slug : page.id)" />
                <div class="flex-wrap p-2 mt-2 -ml-20 text-white bg-gray-700 rounded tooltip whitespace-nowrap">
                  {{ $t("Shared by") }} {{ $utils.getUserById(page.owner)?.first_name }}
                </div></span>
            </div>
            <BlueArcVector
              v-if="
                current_page === (useSlugForStaticPages && page.is_static ? page.slug : page.id) ||
                  page_hovered == (useSlugForStaticPages && page.is_static ? page.slug : page.id)
              "
              :color="getBgColor(useSlugForStaticPages && page.is_static ? page.slug : page.id)"
              class="absolute -left-[1px] -top-1" />
            <BlueArcVector2
              v-if="
                current_page === (useSlugForStaticPages && page.is_static ? page.slug : page.id) ||
                  page_hovered == (useSlugForStaticPages && page.is_static ? page.slug : page.id)
              "
              :color="getBgColor(useSlugForStaticPages && page.is_static ? page.slug : page.id)"
              class="absolute -left-[1px] bottom-0" />
          </li>
        </DisclosurePanel>
      </transition>
    </Disclosure>
  </div>

  <div v-if="!pages.length && !sharedPages.length" class="px-3 py-5 text-sm text-white">
    {{ $t("No pages added.") }} <br>
    {{ $t("Click on the") }} <Settings2 class="inline w-4 h-4 mx-1 text-white" /> {{ $t("icon to add") }}
  </div>
</template>

<script>
import BlueArcVector from "@/components/shared/icons/BlueArcVectorTopLeft.vue"
import BlueArcVector2 from "@/components/shared/icons/BlueArcVectorBottomLeft.vue"
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/vue"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"
import { Share2, LayoutTemplate, ChevronDown, Plus, Settings2 } from "lucide-vue-next"

export default {
  components: {
    Plus,
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    Share2,
    BlueArcVector,
    BlueArcVector2,
    ChevronDown,
    LayoutTemplate,
    Settings2
  },
  props: {
    pages: {
      type: Array,
      default: () => []
    },
    sharedPages: {
      type: Array,
      default: () => []
    },
    useSlugForStaticPages: {
      type: Boolean,
      default: false
    },
    customPageClickFunction: {
      type: Function,
      required: false
    }
  },
  emits: [],
  data() {
    return {
      ALL_EMITTERS,
      page_hovered: null
    }
  },
  computed: {
    current_page() {
      if (this.$route?.params?.page) {
        return this.$route?.params?.page
      }
      return "default"
    },
    active_journey() {
      return this.$route.query.journey
    },
    active_tab() {
      if (this.$route.query.tab) {
        return this.$route.query.tab
      } else {
        if (this.$route.path == "/prospecting") {
          return "prospect"
        }

        if (this.$route.path == "/customer-inbox") {
          return "inbox"
        }
        if (this.$route.path == "/portfolio") {
          return "company"
        }
      }
      return this.$route.query.tab
    }
  },
  watch: {},

  created() {},
  methods: {
    calcGroupOpen(item) {
      if (
        !this.pages[0]?.is_group &&
        this.$store.state.ui?.page_groups_open &&
        this.$store.state.ui?.page_groups_open[this.pages[0]?.page] &&
        this.$store.state.ui?.page_groups_open[this.pages[0]?.page][item.name]
      ) {
        return this.$store.state.ui?.page_groups_open[this.pages[0]?.page][item.name]
      }

      if (
        this.pages[0]?.is_group &&
        this.$store.state.ui?.page_groups_open &&
        this.$store.state.ui?.page_groups_open[this.pages[0]?.pages[0]] &&
        this.$store.state.ui?.page_groups_open[this.pages[0]?.pages[0]?.page][item.name]
      ) {
        return this.$store.state.ui?.page_groups_open[this.pages[0]?.pages[0]?.page][item.name]
      }
      return false
    },
    calcSharedGroupOpen() {
      if (
        this.$store.state.ui?.page_groups_open &&
        this.$store.state.ui?.page_groups_open[this.pages[0]?.page] &&
        this.$store.state.ui?.page_groups_open[this.pages[0]?.page]["Shared Pages"]
      ) {
        return this.$store.state.ui?.page_groups_open[this.pages[0]?.page]["Shared Pages"]
      }
      return false
    },
    handleOpenGroup(group, open) {
      let page_groups_open = this.$utils.clone(this.$store.state.ui?.page_groups_open)

      const module_name = this.pages[0].is_group ? this.pages[0].pages[0].page : this.pages[0].page

      if (page_groups_open) {
        if (page_groups_open[module_name]) {
          page_groups_open[module_name][group.name] = open
        } else {
          page_groups_open[module_name] = {
            [group.name]: open
          }
        }
      } else {
        page_groups_open = { [module_name]: { [group.name]: open } }
      }
      this.$store.dispatch("ui/setUIValue", {
        page_groups_open: page_groups_open
      })
    },

    handleOpenShared(open) {
      let page_groups_open = this.$utils.clone(this.$store.state.ui?.page_groups_open)
      const module_name = this.sharedPages[0].is_group ? this.pages[0].pages[0].page : this.pages[0].page

      if (page_groups_open) {
        if (page_groups_open[module_name]) {
          page_groups_open[module_name]["Shared Pages"] = open
        } else {
          page_groups_open[module_name] = {
            ["Shared Pages"]: open
          }
        }
      } else {
        page_groups_open = { [module_name]: { ["Shared Pages"]: open } }
      }
      this.$store.dispatch("ui/setUIValue", {
        page_groups_open: page_groups_open
      })
    },
    getSharedWithText(shared_with_list) {
      if (shared_with_list.length > 2) {
        return `${shared_with_list.length} ` + this.$t("people")
      } else if (shared_with_list.length == 1) {
        return `${this.$utils.getUserById(shared_with_list[0].id).first_name}`
      } else {
        return (
          `${this.$utils.getUserById(shared_with_list[0].id).first_name} ` +
          this.$t("and") +
          ` ${this.$utils.getUserById(shared_with_list[1].id).first_name}`
        )
      }
    },
    getIconColor(value) {
      if (this.page_hovered == value && this.active_tab != value && this.current_page != value && this.active_journey != value) {
        return "#FFFFFF"
      }
      return "#FFFFFF"
    },
    getTwBgColor(value) {
      if (this.active_tab == value || this.current_page == value || this.active_journey == value) {
        return this.$store.state.ui_options.theme?.selected_item_color
      }
      return this.$store.state.ui_options.theme?.selected_item_color
    },
    getBgColor(value) {
      if (this.active_tab == value || this.current_page == value || this.active_journey == value) {
        return this.$store.state.ui_options.theme?.selected_item_color
      }
      return this.$store.state.ui_options.theme?.selected_item_color
    },
    getTextColor(value) {
      if (this.active_tab == value || this.current_page == value || this.active_journey == value) {
        return "text-white"
      }
      return "text-white"
    }
  }
}
</script>
